import React, { useEffect } from "react";
import { useMutation } from "react-query";
import { GetLoanTemplateDetailById } from "../../services/loanTemplate.service";
import { LOANPLANTYPEID } from "../../config/cacheKey";
import { Grid, Typography } from "@mui/material";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import { useHistory } from "react-router-dom";
import DivisionCmp from "../../components/cards/DivisionCmp";
import SpecificationsPlan from "./specificationsPlan";
import {
  FinancialSuppliers,
  GetLoanTemplateDetailByIdResponse,
} from "../../models/loanTemplate.model";
import TableCreator from "../../components/table/tableCreator";
import { ColumnModel } from "../../models/common.model";
import ArrowLeftOutlinedIcon from "@mui/icons-material/ArrowLeftOutlined";
import LoanPlanDetailSkeleton from "./LoanPlanDetailSkeleton";
import LinearGradientBox from "../../components/box/linearGradientBox";
import { unset } from "lodash";
export default function LoanPlanDetail() {
  const [data, setData] = React.useState<GetLoanTemplateDetailByIdResponse>();
  const history = useHistory();
  const {
    mutateAsync: GetLoanTemplateDetailByIdMutate,
    isLoading,
  } = useMutation(GetLoanTemplateDetailById, {
    onSuccess: (res) => {
      setData(res);
    },
  });
  useEffect(() => {
    const id = localStorage.getItem(LOANPLANTYPEID);
    GetLoanTemplateDetailByIdMutate({ loanTemplateId: Number(id) });
  }, []);
  const handleBack = () => {
    history.push("/plans/loanPlans");
  };
  const columns: readonly ColumnModel[] = [
    { id: "title", label: " نام سازمان" },
    { id: "financialSupplierTitlesString", label: "تامین کنندگان مالی " },
    { id: "isActive", label: "وضعیت " },
  ];
  const financialSuppliersColumns: readonly ColumnModel[] = [
    { id: "interestRate", label: " نرخ سود تسهیلات " },
    {
      id: "minimumAmount",
      label: "حداقل  مبلغ (ريال) ",
      hasFormat: true,
      format: (value: number) => {
        return value.toLocaleString("fa");
      },
    },
    {
      id: "maximumAmount",
      label: "حداکثر مبلغ (ريال) ",
      hasFormat: true,
      format: (value: number) => {
        return value.toLocaleString("fa");
      },
    },
    { id: "durationByMonth", label: "طول مدت بازپرداخت" },
    { id: "stepSpaceByMonth", label: "فاصله اقساط " },
    { id: "customerFeePercentage", label: "نرخ کارمزد مشتری " },
    { id: "supplierFeePercentage", label: "نرخ کارمزد پذیرنده " },
    { id: "isActive", label: "وضعیت " },
    { id: "customerGuarantyChequeRequired", label: "نیازمند چک ضمانت متقاضی " },
    { id: "guarantorCount", label: "تعداد ضامن مورد نیاز " },
    { id: "feePaymentTypeTitle", label: " نوع پرداخت هزینه اشتراک" },
  ];
  if (isLoading) {
    return <LoanPlanDetailSkeleton />;
  }
  return (
    <div>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        bgcolor={"#F6F8F9"}
        spacing={2}
        sx={{
          borderRadius: 2,
          p: 2,
          border: "1px solid #EDEFEF",
          flexDirection: {
            xs: "column",
            md: "row",
          },
          mt: 1,
        }}
      >
        <Grid
          item
          md={7}
          xs={12}
          container
          sx={{
            order: {
              xs: 2,
              md: 1,
            },
            flexDirection: {
              xs: "column",
              md: "row",
            },
            justifyContent: {
              xs: "center",
              md: "flex-start",
            },
            alignItems: "center",
            textAlign: {
              xs: "center",
              md: "right",
            },
          }}
        >
          <Grid item>
            {/* <StyledBadge badgeContent="غیرفعال" color="error"> */}
            <LinearGradientBox
              color={data?.loanTemplateDetail.walletTypeColorHexCode || "red"}
            />
            {/* <img
              src={`data:image/png;base64,${data?.loanTemplateDetail.walletTypeLogo}`}
              alt="plan"
              style={{ objectFit: "contain", borderRadius: "4px" }}
            /> */}
            {/* </StyledBadge> */}
          </Grid>
          <Grid
            item
            sm={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: { xs: "center", md: "flex-start" },
            }}
          >
            <Typography variant="h6" mt={1}>
              {data?.loanTemplateDetail.loanTemplateTitle}{" "}
              {data?.loanTemplateDetail.isActive == true ? (
                <b style={{ color: "#28A745" }}>(فعال)</b>
              ) : (
                <b style={{ color: "#E6123D" }}>(غیرفعال)</b>
              )}
            </Typography>
            {data?.loanTemplateDetail.walletTypeTitle && (
              <Typography
                mt={1}
                sx={{
                  backgroundColor: "#1D4A87",
                  paddingX: 1,
                  paddingY: 0.5,
                  borderRadius: "8px",
                  width: "fit-content",
                  color: "white",
                }}
              >
                {data?.loanTemplateDetail.walletTypeTitle}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={5}
          textAlign={"left"}
          onClick={() => handleBack()}
          sx={{
            order: {
              xs: 1,
              md: 2,
            },
            cursor: "pointer",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Typography
            variant="body2"
            fontWeight="bold"
            sx={{ color: "#1D4A87", marginLeft: "10px" }}
          >
            <ArrowForwardIosOutlinedIcon fontSize="small" />
            &nbsp;بازگشت
          </Typography>
        </Grid>
      </Grid>
      {data?.loanTemplateDetail && (
        <DivisionCmp
          child={<SpecificationsPlan item={data?.loanTemplateDetail} />}
          title={"مشخصات طرح"}
          marginTop={"1vh"}
          padding={".5vh"}
        />
      )}
      {data?.organizations && data?.organizations.length > 0 && (
        <div>
          <Typography
            mt={3}
            mb={1}
            color={"#1D4A87"}
            fontWeight={600}
            fontSize={15}
          >
            سازمان های طرف قرارداد
          </Typography>
          <TableCreator
            columns={columns}
            data={data?.organizations}
            pageInfo={undefined}
            lastCol={true}
          />
        </div>
      )}
      {data?.financialSuppliers && data?.financialSuppliers.length > 0 && (
        <div>
          <Typography
            mt={3}
            mb={1}
            color={"#1D4A87"}
            fontWeight={600}
            fontSize={15}
          >
            تامین کنندگان مالی
          </Typography>
          {data?.financialSuppliers.map((item: FinancialSuppliers) => (
            <div
              style={{
                marginTop: "1vh",
                backgroundColor: "#F6F8F9",
                border: "1.5px solid #EDEFEF",
                borderRadius: "4px",
                padding: 2,
              }}
            >
              <Typography
                variant="h6"
                mt={2}
                mb={1}
                color={"#1D4A87"}
                fontWeight={400}
              >
                <ArrowLeftOutlinedIcon fontSize="large" />
                <img
                  src={`data:image/png;base64,${item.logo}`}
                  alt="plan"
                  style={{
                    objectFit: "contain",
                    borderRadius: "4px",
                    height: "45px",
                    width: "45px",
                  }}
                />
                &nbsp; {item.title}
              </Typography>
              <TableCreator
                columns={financialSuppliersColumns}
                data={item.detail}
                pageInfo={undefined}
                lastCol={true}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
